import type {
  ApiContext,
  ApiNotAuthorized,
  InvalidFormField,
  StoreNotFound,
  StoreRoleForbidden,
  StoreTaxSettings,
  TaxCollectionRefused,
} from "@hobbyshopify/backend-client";
import type { AsyncResult } from "operation-result.js";
import type { AuthHandler } from "trunk.js";
import type { BackendApi } from "./api";

/** The sales tax switch next to the Stripe Tax state it depends on. Every read re-asks Stripe. */
export function loadTaxSettings(o: {
  client: BackendApi;
  authHandler: AuthHandler<ApiContext>;
  storeId: string;
}): AsyncResult<StoreTaxSettings, ApiNotAuthorized | StoreNotFound> {
  return o.authHandler.callApi((ctx) => o.client.stores.tax(ctx, o.storeId));
}

/** Turning it on needs a branch with a complete address; turning it off is always allowed. */
export function setCollectSalesTax(o: {
  client: BackendApi;
  authHandler: AuthHandler<ApiContext>;
  storeId: string;
  collectSalesTax: boolean;
}): AsyncResult<
  StoreTaxSettings,
  ApiNotAuthorized | StoreNotFound | StoreRoleForbidden | TaxCollectionRefused | InvalidFormField
> {
  return o.authHandler.callApi((ctx) => o.client.stores.setTax(ctx, o.storeId, o.collectSalesTax));
}
